var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9028 6.09087H7.96359V8.9667H11.9569C11.5853 10.7942 10.0294 11.8442 7.96359 11.8442C7.38553 11.8452 6.81297 11.732 6.27874 11.5113C5.74451 11.2905 5.25912 10.9664 4.85041 10.5576C4.4417 10.1488 4.11772 9.66338 3.89704 9.12911C3.67636 8.59484 3.56332 8.02225 3.56442 7.4442C3.56343 6.86621 3.67655 6.29372 3.89728 5.75954C4.11801 5.22536 4.44201 4.74001 4.8507 4.33131C5.2594 3.92262 5.74475 3.59861 6.27893 3.37789C6.81311 3.15716 7.3856 3.04404 7.96359 3.04503C9.01276 3.04503 9.96109 3.41753 10.7053 4.0267L12.8719 1.86087C11.5519 0.710032 9.85942 3.1715e-05 7.96359 3.1715e-05C6.9851 -0.00282843 6.01569 0.18779 5.11113 0.560923C4.20657 0.934056 3.3847 1.48234 2.6928 2.17424C2.0009 2.86615 1.45261 3.68801 1.07948 4.59257C0.706347 5.49713 0.515729 6.46654 0.518589 7.44503C0.515618 8.42356 0.706161 9.39301 1.07926 10.2976C1.45235 11.2022 2.00063 12.0241 2.69255 12.7161C3.38448 13.408 4.20639 13.9563 5.111 14.3294C6.01561 14.7025 6.98506 14.893 7.96359 14.89C11.6861 14.89 15.0711 12.1825 15.0711 7.44503C15.0711 7.00503 15.0036 6.53087 14.9028 6.09087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.5dfbd8f4c2cd8b9e7b22930dc5e8fdb5.svg";
export { ForwardRef as ReactComponent };